<template>
  <div>
    
    <!-- Search Area Starts -->
    <div class="search-area"  style="display: none;">
      <div class="search-bg">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <form action="#" class="d-md-flex justify-content-between">
                <select>
                  <option value="1">所有产品</option>
                  <option value="2">水泥罐搅拌站专用</option>
                  <option value="3">混凝土搅拌站大型</option>
                  <option value="4">数控全自动JS750</option>
                  <option value="5">供应滚筒式混凝土</option>
                </select>
                <select>

                  <option value="1">选择型号</option>
                  <option value="2">HZS35混凝土搅拌站</option>
                  <option value="3">HZS50混凝土搅拌站</option>
                  <option value="4">HZS60混凝土搅拌站</option>
                  <option value="5">HZS75混凝土搅拌站</option>
                </select>
                <input type="text" placeholder="搜索关键字" onfocus="this.placeholder = ''"
                       onblur="this.placeholder = '搜索关键字'" required>
                <button type="submit" class="template-btn">搜索</button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Search Area End -->


    <!-- Jobs Area Starts -->
    <section class="jobs-area section-padding"  style="display: none;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="single-job mb-4 d-lg-flex justify-content-between">
                <div class="job-text">
                    <h4>化工产品研发工程师l</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> 上海-闵行区</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>
                          3-4年经验  |  本科  |  01-13发布  |  英语一般</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> 2022-9-9</h5></li>
                    </ul>
                  </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job1.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                 <a href="#" class="third-btn job-btn4">全职</a>
                    <a href="#" class="third-btn">投递</a>
              </div>
            </div>
            <div class="single-job mb-4 d-lg-flex justify-content-between">
              <div class="job-text">
                    <h4>化工实验室研究员/技术员</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i>上海</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>
                         |  1年经验  |  本科  |  01-13发布  |  英语良好</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> 2022-9-9</h5></li>
                    </ul>
                  </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job2.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                <a href="#" class="third-btn job-btn4">全职</a>
                    <a href="#" class="third-btn">投递</a>
              </div>
            </div>
            <div class="single-job mb-4 d-lg-flex justify-content-between">
              <div class="job-text">
                    <h4>管道设计工程师（化工类）</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> 上海-松江区</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>
                          |  3-4年经验  |  本科  |  01-13发布</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i> 2022-9-9</h5></li>
                    </ul>
                  </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job3.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                <a href="#" class="third-btn job-btn4">全职</a>
                    <a href="#" class="third-btn">投递</a>
              </div>
            </div>
            <div class="single-job mb-4 d-lg-flex justify-content-between">
          <div class="job-text">
                    <h4>化工质检员（包住+年底双薪）</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i>武汉-东湖新技术产业开发区</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>
                         |  无需经验  |  中技/中专  |  01-13发布</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i>2022-9-9</h5></li>
                    </ul>
                  </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job4.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
                 <a href="#" class="third-btn job-btn4">全职</a>
                    <a href="#" class="third-btn">投递</a>
              </div>
            </div>
            <div class="single-job d-lg-flex justify-content-between">
           <div class="job-text">
                    <h4>化工质检员（包住+年底双薪）</h4>
                    <ul class="mt-4">
                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i>武汉-东湖新技术产业开发区</h5></li>
                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>
                         |  无需经验  |  中技/中专  |  01-13发布</h5></li>
                      <li><h5><i class="fa fa-clock-o"></i>2022-9-9</h5></li>
                    </ul>
                  </div>
              <div class="job-img align-self-center">
                <img src="static/assets/images/job5.png" alt="job">
              </div>
              <div class="job-btn align-self-center">
             <a href="#" class="third-btn job-btn4">全职</a>
                    <a href="#" class="third-btn">投递</a>
              </div>
            </div>
          </div>
        </div>
        <div class="more-job-btn mt-5 text-center">
          <a href="#" class="template-btn">更多职务</a>
        </div>
      </div>
    </section>
    <!-- Jobs Area End -->
  </div>
</template>

<script>
  export default {}
</script>




// WEBPACK FOOTER //
// JobSearch.vue?0b53999d